import 'core-js/stable';
import 'regenerator-runtime/runtime';
import DropdownFilter from './DropdownFilter';

class Wijkerbaan {
  static init() {
    /* eslint-disable-next-line */
    new DropdownFilter({
      filterTarget: $('.lot-selector-areas, .stores-list'),
    });

    $('.lot-selector-area').on('mouseenter', event => Wijkerbaan.markStoreInList(event));
    $('.lot-selector-area').on('mouseleave', () => Wijkerbaan.removeMarkedListItems());

    $('.stores-list li').on('mouseenter', event => Wijkerbaan.markMarker(event));
    $('.stores-list li').on('mouseleave', () => Wijkerbaan.removeMarkedMarkers());
  }

  static markStoreInList(event) {
    const storeTitle = $(event.currentTarget).data('popup-target');
    
    $(`.stores-list li[data-title=${storeTitle}]`).addClass('marked');
  }

  static removeMarkedListItems() {
    $('.stores-list .marked').removeClass('marked');
  }

  static markMarker(event) {
    const storeTitle = $(event.currentTarget).data('title');
    $(`.lot-selector-area[data-popup-target=${storeTitle}]`).addClass('marked');
  }

  static removeMarkedMarkers() {
    $('.lot-selector-area.marked').removeClass('marked');
  }
}

$(document).ready(() => {
  Wijkerbaan.init();
});
